import {swalError} from "./core";

class Messages {

    // Content message
    contentMessage() {
        let $modal = $('#messages-modal');

        $modal.on('show.bs.modal', function (event) {
            let $modal = $('.message-modal');
            let $target = $(event.relatedTarget);
            let route = $target.data('route');
            let notification = $target.data('id');

            $modal.find('#loader-message-modal').show();
            $modal.find('#modal-message-print').html('');
            $modal.find('.modal-image').html('');
            $modal.find('#modal-message-title').html($target.data('title'));
            $modal.find('#modal-message-date').html($target.data('date'));

            $.ajax({
                url: route,
                method: 'post',
                data: {
                    id: notification
                }
            }).done(function (json) {
                $modal.find('#loader-message-modal').hide();
                $modal.find('#modal-message-print').append(json.content);

                if (json.image != null) {
                    $modal.find('.modal-image').append(json.image);
                }

            }).fail(function (json) {
                swalError(json);
            });
        });
    }

    // Messages
    messages() {
        let $table = $('#messages-table');

        $table.DataTable({
            "asStripeClasses": [''],
            "scrollCollapse": false,
            "info": false,
            "ajax": {
                "url": $table.data('route'),
                "dataSrc": "data.notifications"
            },
            "order": [[0, "desc"]],
            "columns": [
                {"data": "title", "className": "msg-table-text"},
                {"data": "date", "className": "msg-table-date"},
                {"data": "button", "className": "msg-table-btn"}
            ]
        });
    }
}

window.Messages = Messages;